import { render, staticRenderFns } from "./Consumption.html?vue&type=template&id=57228c15&"
import script from "./Consumption.js?vue&type=script&lang=js&"
export * from "./Consumption.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports